import React from "react";

const Button = ({
  className = "",
  label,
  onClick,
  type = "button",
  size = "medium",
  variant = "primary",
  disabled = false,
  icon = null,
  style = {},
}) => {
  return (
    <button
      type={type}
      className={`customBtn customBtn-${variant} customBtn-${size}`}
      onClick={onClick}
      disabled={disabled}
      style={{ ...style }}
    >
      {icon && (
        <div
          className="bt-icon d-flex align-items-center"
          style={{ fontSize: 20 }}
        >
          {icon}
        </div>
      )}
      {label}
    </button>
  );
};

export default Button;
